import React, { useEffect, useState } from "react";
import { api, API } from "@/lib/api";

const DEFAULTS = {
  logo_url: "/arps-logo.png",
  business_name: "Audit Ready Process Service",
  tagline: "Every Service. Every Attempt. Every Detail. Documented.",
};

let _cache = null;
const _listeners = new Set();

export function refreshBranding(next) {
  _cache = next ? { ...DEFAULTS, ...next } : null;
  _listeners.forEach((fn) => fn(_cache || DEFAULTS));
}

export function useBranding() {
  const [b, setB] = useState(_cache || DEFAULTS);
  useEffect(() => {
    const fn = (val) => setB(val || DEFAULTS);
    _listeners.add(fn);
    if (_cache) setB(_cache);
    else api.get("/branding").then(({ data }) => refreshBranding(data)).catch(() => {});
    return () => { _listeners.delete(fn); };
  }, []);
  return b;
}

export function brandSrc(logo_url) {
  if (!logo_url) return DEFAULTS.logo_url;
  return logo_url.startsWith("/api") ? `${API}${logo_url.replace("/api", "")}` : logo_url;
}

export function BrandLogo({ className = "h-12 w-auto", showName = false, nameClass = "" }) {
  const b = useBranding();
  return (
    <div className="flex items-center gap-3">
      <img data-testid="brand-logo" src={brandSrc(b.logo_url)} alt={b.business_name} className={className} />
      {showName && <span data-testid="brand-name" className={nameClass}>{b.business_name}</span>}
    </div>
  );
}
